<template>
  <v-dialog v-model="dialog" max-width="600px" persistent>
    <v-card>
      <v-card-title class="text-h6 primary white--text">
        إضافة طلب لسلة التحويل
        <v-spacer></v-spacer>
        <v-btn icon dark @click="closeDialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="pt-6">
        <v-form ref="form" v-model="valid">
          <v-row>
            <v-col cols="12">
              <div class="mb-2 font-weight-bold">
                رقم الطلب: {{ qualityRequestId }}
              </div>
            </v-col>

            <v-col cols="12">
              <v-textarea v-model="note" label="ملاحظة الجودة *"
                placeholder="ملاحظة الجودة مطلوبة لإضافة الطلب لسلة التحويل" outlined rows="5" counter="1000"
                :rules="noteRules" :error-messages="errorMessages" >
                <template v-slot:prepend-inner>
                  <v-icon color="primary">mdi-note-text</v-icon>
                </template>
              </v-textarea>
            </v-col>

            <v-col cols="12" v-if="!note || note.trim().length === 0">
              <v-alert dense text type="warning" class="mb-0">
                <small>
                  يجب إضافة ملاحظة الجودة أولاً قبل إضافة الطلب لسلة التحويل. الرجاء حفظ الطلب مع ملاحظة الجودة أولاً.
                </small>
              </v-alert>
            </v-col>

            <v-col cols="12" v-else>
              <v-alert dense text type="info" class="mb-0">
                <small>
                  سيتم استخدام ملاحظة الجودة كسبب للتحويل وإرسالها للاستشاري المسؤول عن الطلب
                </small>
              </v-alert>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-card-actions class="px-6 pb-6">
        <v-spacer></v-spacer>
        <v-btn color="grey" text @click="closeDialog" :disabled="loading">
          إلغاء
        </v-btn>
        <v-btn color="primary" depressed @click="submitTransfer" :loading="loading"
          :disabled="!valid || loading || !note || note.trim().length === 0">
          <v-icon left>mdi-check</v-icon>
          إضافة للسلة
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { axiosInstance } from "@/axios/config";

export default {
  name: "AddToTransferBasketDialog",
  data() {
    return {
      dialog: false,
      valid: false,
      loading: false,
      note: "",
      qualityRequestId: null,
      errorMessages: [],
      noteRules: [
        v => !!v || "ملاحظة الجودة مطلوبة",
        v => (v && v.trim().length >= 5) || "ملاحظة الجودة يجب أن تكون 5 أحرف على الأقل",
        v => (v && v.trim().length <= 1000) || "ملاحظة الجودة يجب ألا تتجاوز 1000 حرف",
      ],
    };
  },
  mounted() {
    this.$root.$on("OPEN_TRANSFER_BASKET_DIALOG", (qualityReqId, quacomment = null) => {
      this.openDialog(qualityReqId, quacomment);
    });
  },
  beforeDestroy() {
    this.$root.$off("OPEN_TRANSFER_BASKET_DIALOG");
  },
  methods: {
    openDialog(qualityReqId, quacomment = null) {
      this.qualityRequestId = qualityReqId;
      this.errorMessages = [];
      this.note = quacomment || this.$store.state.request_info?.quacomment || "";
      this.dialog = true;
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    },
    closeDialog() {
      this.dialog = false;
      this.note = "";
      this.qualityRequestId = null;
      this.errorMessages = [];
      if (this.$refs.form) {
        this.$refs.form.reset();
      }
    },
    async submitTransfer() {
      if (!this.$refs.form.validate()) {
        return;
      }

      if (!this.note || this.note.trim().length === 0) {
        this.showPopup("error", "يجب إضافة ملاحظة الجودة أولاً");
        return;
      }

      this.loading = true;
      this.errorMessages = [];

      const formData = new FormData();
      formData.append("quality_req_id", this.qualityRequestId);
      formData.append("note", this.note);

      try {
        const response = await axiosInstance.post(
          "/employee/quality/addNeedToBeTurnedReq",
          formData,
          {
            headers: this.request_headers(),
          }
        );

        this.showPopup("success", response.data.message || "تم إضافة الطلب لسلة التحويل بنجاح");

        this.$root.$emit("REFRESHCARDDATA");

        this.closeDialog();
      } catch (err) {
        if (err.response && err.response.data) {
          const errorMsg = err.response.data.message;
          if (Array.isArray(errorMsg)) {
            this.errorMessages = errorMsg;
          } else {
            this.showPopup("error", errorMsg);
          }
        } else {
          this.showPopup("error", "حدث خطأ أثناء إضافة الطلب");
        }
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.v-card__title {
  border-bottom: 1px solid #e0e0e0;
}
</style>